function load_tracking_script()
{
    (function (e, t, n) {
        var r, i = e.getElementsByTagName(t)[0];
        if (e.getElementById(n))return;
        r = e.createElement(t);
        r.id = n;
        r.src = "https://button.aftership.com/all.js";
        i.parentNode.insertBefore(r, i)
    })(document, "script", "aftership-jssdk")
}

jQuery(document).ready(function($){
    $("body").on('click', '.show-lost-password-frm', function(e){
        e.preventDefault();
        $("#recover").show();
    });
    var timer = setInterval(function(){
        if($('.as-track-button').is(':visible')) {
            load_tracking_script();
        }
    }, 300);
});